import script from "./rightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./rightBar.vue?vue&type=script&setup=true&lang=js"

export default script